import { render, staticRenderFns } from "./ImportResultPage.vue?vue&type=template&id=415ed2c6&"
import script from "./ImportResultPage.vue?vue&type=script&lang=js&"
export * from "./ImportResultPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports